export const FOOTER_HEIGHT = 234;
export const HEADER_DESKTOP_HEIGHT = 110;
export const HEADER_MOBILE_HEIGHT = 50;
export const HEADER_UNIFIED_DESKTOP_HEIGHT = 64;
export const HEADER_UNIFIED_MOBILE_HEIGHT = 96;
export const HEADER_UNIFIED_USER_MENU_HEIGHT = 32;
export const HEADER_UNIFIED_DESKTOP_OVERLAY_TOP_POSITION = 48;
export const HEADER_UNIFIED_MOBILE_OVERLAY_TOP_POSITION = 78;
